/**
 * AdminAlertRpcClient - AtomRpc integration for admin alert endpoints
 *
 * Requires admin authentication via Clerk session token.
 *
 * @since 1.0.0
 */
import { AtomRpc } from "@effect-atom/atom-react";
import { FetchHttpClient } from "@effect/platform";
import { RpcSerialization } from "@effect/rpc";
import { AdminAlertRpcs } from "@fm/api/rpc";
import { Layer } from "effect";
import { makeRpcClientLayer, makeTokenGetterLayer } from "./shared.ts";

export class AdminAlertRpcClient extends AtomRpc.Tag<AdminAlertRpcClient>()(
  "AdminAlertRpcClient",
  {
    group: AdminAlertRpcs,
    protocol: makeRpcClientLayer(AdminAlertRpcs).pipe(
      Layer.provide(RpcSerialization.layerNdjson),
      Layer.provide(makeTokenGetterLayer()),
      Layer.provide(FetchHttpClient.layer),
    ),
  },
) {}
